import BaseModulePlugins from '@/store/baseModule/plugins';

export default (store, modulePath) => {
  const basePlugin = new BaseModulePlugins({
    paramId: 'actionId',
    module: modulePath,
    store,
  });

  store.dispatch(`${modulePath}/toogleViewTable`);

  basePlugin.onInit(() => {
    basePlugin.loadItemsOnCurrentChange({});

    basePlugin.onItemAddedOrModified(() => {
      store.dispatch(`${modulePath}/refreshItems`);
    });
    basePlugin.onItemDeleted(() => {
      store.dispatch(`${modulePath}/refreshItems`);
    });
  });
};
